import React, { useState, useEffect } from "react";
import {
  Collapse, Button, Form, Input, Select, Row, Col
} from "antd";
import { QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import UploadButton from "../common/UploadButton";
import globalData from "../../config/global_data";
import { triggerNotification } from "../common/notify";
const { Panel } = Collapse;

const VariantProductItem = ({ product, onRemove, onUpdate, setProduct, products, form, index, setHasDuplicateError }) => {
  const [savedimages, setSavedimgaes] = useState(null);
  const [data, setData] = useState(null);
  const [options, setOptions] = useState([])
  const [selectedSKU, setSelectedSKU] = useState()
  const [imageObj, setImageObj] = useState(null);

  const handleInputChange = (name) => (e) => {
    let value = e.target.value.replace(/[^\d]/g, ''); // allow digits only    
    setData(prev => ({ ...prev, [name]: value }));
  };

  useEffect(() => {

    if (product) {
      setData(product)
      form.setFieldsValue({
        products: {
          [index]: {
            name: product.name,
            sku: product.variant_sku,
            msrp: product.variant_msrp,
            variant_sale_price: product.variant_sale_price
          },
        },
      });
      if (globalData && globalData.sap_sku_list && globalData.sap_sku_list.length > 0) {
        let sap_list = []
        let sapsku = globalData.sap_sku_list.filter(item => item.store_id === product.store_id && item.prod_count < 1 && item.variant_count < 1)
        
        
        setOptions(sapsku)
        form.setFieldsValue({
          products: {
            [index]: {             
              sku: product.variant_sku
            },
          },
        });

        if (!product.is_new) {
          if (product.variant_image == "")
            setImageObj({ img_data: [] })
          else
            setImageObj({ img_data: [{ url_standard: product.variant_image }] })

        }
        if (product.variant_sku != "") {
          setSelectedSKU(product.variant_sku)
        }
        // productSku${product.variant_sku}
      }


    }
  }, [])
  useEffect(() => {
    if (data) {
      let updated_products = products.map(item => {
        if (item.id !== 0 && item.id === product.id) {
          return { ...item, ...data }
        }
        else if (item.variant_sku !== 0 && item.variant_sku === product.variant_sku) {
          return { ...item, ...data }
        } else {
          return item
        }
      }
      );
      setProduct(updated_products);
    }
  }, [data, setProduct]);

  useEffect(() => {
    if (savedimages && savedimages.image_data && savedimages.image_data.length > 0) {
      setData({ ...data, variant_image: savedimages.image_data[0].thumbUrl })
    }
    if (savedimages && savedimages.image_data && savedimages.image_data.length == 0) {
      setData({ ...data, variant_image: null })
    }
  }, [savedimages])
  const handleNameChange = (e) => {
    if (product.options && product.options.length > 0)
      product.options[0].label = e.target.value
    setData({ ...data, name: e.target.value })
    onUpdate(product.id, { name: e.target.value });
  };

  const handleChange = async (value) => {

    if (product.is_new) {

      let selecteddata = await options.filter(item => item.sap_sku == value && item.store_id === product.store_id)

      if (selecteddata && selecteddata.length > 0) {

        setData({
          ...data,
          variant_sku: selecteddata[0].sap_sku,
          variant_sale_price: selecteddata[0].sap_sale,
          sap_msrp: selecteddata[0].sap_msrp,
          sap_sale: selecteddata[0].sap_sale,
          variant_msrp: selecteddata[0].sap_msrp,
          inventory_available: selecteddata[0].inventory_reserved
        })

      }

    }
  };
  const collapseItems = [
    {
      key: product.id,
      label: data && (
        <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <span> <span>{data.name || 'New Variant'}</span></span>
        </span>
      ),
      children: data && (
        <>
          <div className="variantProductItemRow" key={data.id}>
            <Form.Item
              className="col-33"
              label="Variant Value"
              name={['products', index, 'name']}
              initialValue={data.name}
              rules={[
                {
                  required: true,
                  message: "Please Enter a Variant Value",
                },
                {
                  validator: (_, value) => {
                    if (value && value.trim() === "") {
                      if (setHasDuplicateError) setHasDuplicateError(false);
                      return Promise.reject("Only spaces are not allowed");
                    }
                    // Duplicate check (case-insensitive, trimmed)
                    const trimmedValue = value ? value.trim().toLowerCase() : "";
                    const duplicate = products.some((p, idx) =>
                      idx !== index &&
                      p.name &&
                      p.name.trim().toLowerCase() === trimmedValue
                    );
                    if (duplicate) {
                      if (setHasDuplicateError) setHasDuplicateError(true);
                      return Promise.reject("Duplicate variant value not allowed");
                    }
                    if (setHasDuplicateError) setHasDuplicateError(false);
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                placeholder="Enter a Variant Value"
                value={data.name}
                onChange={handleNameChange}
                maxLength={150}
              />
            </Form.Item>

            <Form.Item
              className="col-33"
              label="SKU"
              initialValue={data.sku}
              name={['products', index, 'sku']}
              rules={[{ required: true, message: "Please Select SKU" }]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                value={selectedSKU}
                style={{ width: "100%" }}
                placeholder="Select SKU"
                onChange={handleChange}
                options={options}
              />
            </Form.Item>

            <Form.Item
              className="col-33"
              label="Default Price"
            >
              <Input
                placeholder="Default Price"
                prefix={data.currency_symbol}
                value={data.variant_default_price}
                onChange={handleInputChange('variant_default_price')}
              />
            </Form.Item>
            <Row className="col-50" gutter={8}>
              <Col span={12}>
                <Form.Item
                  label="SAP MSRP"
                >
                  <Input
                    prefix={data.currency_symbol}
                    placeholder="SAP MSRP"
                    value={data.sap_msrp}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="SAP Sale Price"
                >
                  <Input
                    prefix={data.currency_symbol}
                    placeholder="SAP Sale Price"
                    value={data.sap_sale}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className="col-50" gutter={8}>
              <Col span={12}>
                <Form.Item
                  label="MSRP"
                  name={['products', index, 'msrp']}
                  rules={[{ required: true, message: "Please Enter MSRP" }]}
                >
                  <Input
                    placeholder="MSRP"
                    value={data.variant_msrp}
                    onChange={handleInputChange('variant_msrp')}
                    prefix={data.currency_symbol}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Sale Price"
                  name={['products', index, 'variant_sale_price']}                 
                  rules={[
                  { required: true, message: "Please enter the sale price" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const msrp = parseFloat(getFieldValue(['products', index, 'msrp']));
                      const sale = parseFloat(value);
                      if (!value || isNaN(msrp) || isNaN(sale) || sale <= msrp) {
                        return Promise.resolve();
                      }
                      return Promise.reject('Sale Price cannot be greater than MSRP');
                    },
                  }),
                ]}
                >
                  <Input
                    placeholder="Sale Price"
                    value={data.variant_sale_price}
                    onChange={handleInputChange('variant_sale_price')}
                    prefix={data.currency_symbol}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={8} className="col-50">
              <Col span={12}>
                <Form.Item label="Current Stock">
                  <Input
                    placeholder="Current Stock"
                    value={data.inventory_available}
                    onChange={handleInputChange('inventory_available')}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Low Stock">
                  <Input
                    placeholder="Low Stock"
                    value={data.inventory_warning_level}
                    onChange={handleInputChange('inventory_warning_level')}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={8} className="col-50">
              <Col span={12}>
                <Form.Item label="Weight (KGS)">
                  <Input
                    placeholder="Weight (KGS)"
                    value={data.weight}
                    onChange={handleInputChange('weight')}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Width (CM)">
                  <Input
                    placeholder="Width (CM)"
                    value={data.width}
                    onChange={handleInputChange('width')}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={8} className="col-50">
              <Col span={12}>
                <Form.Item label="Height (CM)">
                  <Input
                    placeholder="Height (CM)"
                    value={data.height}
                    onChange={handleInputChange('height')}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Depth (CM)">
                  <Input
                    placeholder="Depth (CM)"
                    value={data.depth}
                    onChange={handleInputChange('depth')}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label={
                <span>
                  PDP Gallery&nbsp;
                </span>
              }
              name="PDPGallery"
            >
              <UploadButton
                MAX_UPLOADS="1"
                delete="true"
                replace="true"
                thumbnail="true"
                hover="true"
                setSavedimgaes={setSavedimgaes}
                product_obj={imageObj}
              />
            </Form.Item>
          </div>
        </>
      ),
    }
  ];


  return (
    <Collapse className="ProductDetailsCollapse_inner" items={collapseItems} />

  );
};

export default VariantProductItem;
